import escapeHTML from "./escapeHTML"
import TextSubstitution from "../xmlrdb-metadata/TextSubstitution"

/**
 * @typedef {import("../xmlrdb-data/DataElement").default} DataElement
 * @typedef {import("../xmlrdb-metadata/Tag").default} Tag
 */

 /**
  * @callback processTag
  * @param {DataElement} dataElement
  * @param {Tag} tag
  * @returns {String}
  */

/** @type {processTag} */
function processSub(dataElement, tag, html = false) {
  if(html)
    return `<sub>${escapeHTML(TextSubstitution(tag.value()))}</sub>`;
  else {
    return tag.value()
  }
}

/** @type {processTag} */
function processSup(dataElement, tag, html = false) {
  if(html)
    return `<sup>${escapeHTML(TextSubstitution(tag.value()))}</sup>`;
  else {
    return tag.value()
  }
}

/** @type {processTag} */
function processTagValue(dataElement, tag, html = false) {
  return escapeHTML(TextSubstitution(tag.value()));
}

/** @type {processTag} */
function processFormatter(dataElement, tag, html = false) {
  if(html)
    return tag.value() === "br" ? "<br/>" : "";
  else {
    return "\n";
  }
}

/** @type {processTag} */
function processAttribute(dataElement, tag, html = false) {
  let attributeVal  = dataElement.$[tag.value()];
  if(attributeVal)
    return attributeVal;
  return "";
}


/** @type {processTag} */
function processSubObject(dataElement, tag, html = false) {
  let parts = tag.value().split(",");
  let className = parts[0];
  let attributeName = parts[1];

  let subClasses = dataElement.elementArray.metadata().children.filter(childMeta => childMeta.name() === className);
  if (subClasses.length > 1) {
    throw `Klassenname ${className} in Subobjects für ${dataElement.elementArray.metadata().id()} gesucht und mehrere gefunden ${subClasses.filter(val => val.id()).join(", ")}`;
  }
  else if (subClasses.length === 0) {
    throw `keine Subclass mit dem Namen ${className} in ${dataElement.elementArray.metadata().id()} gefunden`;
  }
  return dataElement.subElements[subClasses[0].id()].dataElements.map(e => e.$[attributeName]).join(" ");
}

let classLabelFormatter = {
  Label: processTagValue,
  ClassLabel: processTagValue,
  LabelSub: processSub,
  LabelSup: processSup,
  LabelFormatter: processFormatter
};

/**
 *
 */
let objectLabelFormatter = {
  Label: processTagValue,
  AttributeLabel: processAttribute,
  SubObjectAttributeLabel: processSubObject,
  ObjectLabel: processTagValue,
  LabelFormatter: processFormatter,
  LabelSub: processSub,
  LabelSup: processSup
}

function getLabel(formatter, dataElement, tags, html = false) {
  return tags.reduce((accumulator, tag) => {
    if (tag.name() in formatter)
      return accumulator + formatter[tag.name()](dataElement, tag, html);
    else
      return accumulator;
  }, "");
}

/**
 * @typedef formatLabel
 * @type {Function}
 * @param {DataElement} dataElement
 * @param {Array<Tag>} tags
 * @returns {String}
 */

/** @type {formatLabel} */
export let getClassLabel = getLabel.bind(null, classLabelFormatter,null);

/** @type {formatLabel} */
export let getObjectLabel = function (dataElement, tags, html = false) {
  return () => {
    if (!dataElement)
      return null;
    return getLabel(objectLabelFormatter, dataElement, tags, html);
  };
}